export default __webpack_public_path__ + "static/media/create-time-block.00f115f4.webp";